/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AuditIndexRouteImport } from './routes/audit.index';
import { Route as CampaignsIndexRouteImport } from './routes/campaigns.index';
import { Route as CampaignsCampaignIdRouteImport } from './routes/campaigns.$campaignId';
import { Route as CampaignsNewRouteImport } from './routes/campaigns.new';
import { Route as ConsentIndexRouteImport } from './routes/consent.index';
import { Route as GuidesIndexRouteImport } from './routes/guides.index';
import { Route as LocationsIndexRouteImport } from './routes/locations.index';
import { Route as PlacementsIndexRouteImport } from './routes/placements.index';
import { Route as PortalIndexRouteImport } from './routes/portal.index';
import { Route as PortalReportingRouteImport } from './routes/portal.reporting';
import { Route as PortalSigninRouteImport } from './routes/portal.signin';
import { Route as ReportingIndexRouteImport } from './routes/reporting.index';
import { Route as SponsorsIndexRouteImport } from './routes/sponsors.index';
import { Route as TeamIndexRouteImport } from './routes/team.index';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AuditIndexRoute = AuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => rootRouteImport,
} as any);
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => rootRouteImport,
} as any);
const CampaignsCampaignIdRoute = CampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => rootRouteImport,
} as any);
const CampaignsNewRoute = CampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => rootRouteImport,
} as any);
const ConsentIndexRoute = ConsentIndexRouteImport.update({
  id: '/consent/',
  path: '/consent/',
  getParentRoute: () => rootRouteImport,
} as any);
const GuidesIndexRoute = GuidesIndexRouteImport.update({
  id: '/guides/',
  path: '/guides/',
  getParentRoute: () => rootRouteImport,
} as any);
const LocationsIndexRoute = LocationsIndexRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => rootRouteImport,
} as any);
const PlacementsIndexRoute = PlacementsIndexRouteImport.update({
  id: '/placements/',
  path: '/placements/',
  getParentRoute: () => rootRouteImport,
} as any);
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/portal/',
  path: '/portal/',
  getParentRoute: () => rootRouteImport,
} as any);
const PortalReportingRoute = PortalReportingRouteImport.update({
  id: '/portal/reporting',
  path: '/portal/reporting',
  getParentRoute: () => rootRouteImport,
} as any);
const PortalSigninRoute = PortalSigninRouteImport.update({
  id: '/portal/signin',
  path: '/portal/signin',
  getParentRoute: () => rootRouteImport,
} as any);
const ReportingIndexRoute = ReportingIndexRouteImport.update({
  id: '/reporting/',
  path: '/reporting/',
  getParentRoute: () => rootRouteImport,
} as any);
const SponsorsIndexRoute = SponsorsIndexRouteImport.update({
  id: '/sponsors/',
  path: '/sponsors/',
  getParentRoute: () => rootRouteImport,
} as any);
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute;
  '/campaigns/new': typeof CampaignsNewRoute;
  '/portal/reporting': typeof PortalReportingRoute;
  '/portal/signin': typeof PortalSigninRoute;
  '/audit/': typeof AuditIndexRoute;
  '/campaigns/': typeof CampaignsIndexRoute;
  '/consent/': typeof ConsentIndexRoute;
  '/guides/': typeof GuidesIndexRoute;
  '/locations/': typeof LocationsIndexRoute;
  '/placements/': typeof PlacementsIndexRoute;
  '/portal/': typeof PortalIndexRoute;
  '/reporting/': typeof ReportingIndexRoute;
  '/sponsors/': typeof SponsorsIndexRoute;
  '/team/': typeof TeamIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute;
  '/campaigns/new': typeof CampaignsNewRoute;
  '/portal/reporting': typeof PortalReportingRoute;
  '/portal/signin': typeof PortalSigninRoute;
  '/audit': typeof AuditIndexRoute;
  '/campaigns': typeof CampaignsIndexRoute;
  '/consent': typeof ConsentIndexRoute;
  '/guides': typeof GuidesIndexRoute;
  '/locations': typeof LocationsIndexRoute;
  '/placements': typeof PlacementsIndexRoute;
  '/portal': typeof PortalIndexRoute;
  '/reporting': typeof ReportingIndexRoute;
  '/sponsors': typeof SponsorsIndexRoute;
  '/team': typeof TeamIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/campaigns/$campaignId': typeof CampaignsCampaignIdRoute;
  '/campaigns/new': typeof CampaignsNewRoute;
  '/portal/reporting': typeof PortalReportingRoute;
  '/portal/signin': typeof PortalSigninRoute;
  '/audit/': typeof AuditIndexRoute;
  '/campaigns/': typeof CampaignsIndexRoute;
  '/consent/': typeof ConsentIndexRoute;
  '/guides/': typeof GuidesIndexRoute;
  '/locations/': typeof LocationsIndexRoute;
  '/placements/': typeof PlacementsIndexRoute;
  '/portal/': typeof PortalIndexRoute;
  '/reporting/': typeof ReportingIndexRoute;
  '/sponsors/': typeof SponsorsIndexRoute;
  '/team/': typeof TeamIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/portal/reporting'
    | '/portal/signin'
    | '/audit/'
    | '/campaigns/'
    | '/consent/'
    | '/guides/'
    | '/locations/'
    | '/placements/'
    | '/portal/'
    | '/reporting/'
    | '/sponsors/'
    | '/team/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/portal/reporting'
    | '/portal/signin'
    | '/audit'
    | '/campaigns'
    | '/consent'
    | '/guides'
    | '/locations'
    | '/placements'
    | '/portal'
    | '/reporting'
    | '/sponsors'
    | '/team';
  id:
    | '__root__'
    | '/'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/portal/reporting'
    | '/portal/signin'
    | '/audit/'
    | '/campaigns/'
    | '/consent/'
    | '/guides/'
    | '/locations/'
    | '/placements/'
    | '/portal/'
    | '/reporting/'
    | '/sponsors/'
    | '/team/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  CampaignsCampaignIdRoute: typeof CampaignsCampaignIdRoute;
  CampaignsNewRoute: typeof CampaignsNewRoute;
  PortalReportingRoute: typeof PortalReportingRoute;
  PortalSigninRoute: typeof PortalSigninRoute;
  AuditIndexRoute: typeof AuditIndexRoute;
  CampaignsIndexRoute: typeof CampaignsIndexRoute;
  ConsentIndexRoute: typeof ConsentIndexRoute;
  GuidesIndexRoute: typeof GuidesIndexRoute;
  LocationsIndexRoute: typeof LocationsIndexRoute;
  PlacementsIndexRoute: typeof PlacementsIndexRoute;
  PortalIndexRoute: typeof PortalIndexRoute;
  ReportingIndexRoute: typeof ReportingIndexRoute;
  SponsorsIndexRoute: typeof SponsorsIndexRoute;
  TeamIndexRoute: typeof TeamIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/audit/': {
      id: '/audit/';
      path: '/audit';
      fullPath: '/audit/';
      preLoaderRoute: typeof AuditIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/campaigns/': {
      id: '/campaigns/';
      path: '/campaigns';
      fullPath: '/campaigns/';
      preLoaderRoute: typeof CampaignsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/campaigns/$campaignId': {
      id: '/campaigns/$campaignId';
      path: '/campaigns/$campaignId';
      fullPath: '/campaigns/$campaignId';
      preLoaderRoute: typeof CampaignsCampaignIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/campaigns/new': {
      id: '/campaigns/new';
      path: '/campaigns/new';
      fullPath: '/campaigns/new';
      preLoaderRoute: typeof CampaignsNewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/consent/': {
      id: '/consent/';
      path: '/consent';
      fullPath: '/consent/';
      preLoaderRoute: typeof ConsentIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/guides/': {
      id: '/guides/';
      path: '/guides';
      fullPath: '/guides/';
      preLoaderRoute: typeof GuidesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/locations/': {
      id: '/locations/';
      path: '/locations';
      fullPath: '/locations/';
      preLoaderRoute: typeof LocationsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/placements/': {
      id: '/placements/';
      path: '/placements';
      fullPath: '/placements/';
      preLoaderRoute: typeof PlacementsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/portal/': {
      id: '/portal/';
      path: '/portal';
      fullPath: '/portal/';
      preLoaderRoute: typeof PortalIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/portal/reporting': {
      id: '/portal/reporting';
      path: '/portal/reporting';
      fullPath: '/portal/reporting';
      preLoaderRoute: typeof PortalReportingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/portal/signin': {
      id: '/portal/signin';
      path: '/portal/signin';
      fullPath: '/portal/signin';
      preLoaderRoute: typeof PortalSigninRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reporting/': {
      id: '/reporting/';
      path: '/reporting';
      fullPath: '/reporting/';
      preLoaderRoute: typeof ReportingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sponsors/': {
      id: '/sponsors/';
      path: '/sponsors';
      fullPath: '/sponsors/';
      preLoaderRoute: typeof SponsorsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/team/': {
      id: '/team/';
      path: '/team';
      fullPath: '/team/';
      preLoaderRoute: typeof TeamIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CampaignsCampaignIdRoute: CampaignsCampaignIdRoute,
  CampaignsNewRoute: CampaignsNewRoute,
  PortalReportingRoute: PortalReportingRoute,
  PortalSigninRoute: PortalSigninRoute,
  AuditIndexRoute: AuditIndexRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
  ConsentIndexRoute: ConsentIndexRoute,
  GuidesIndexRoute: GuidesIndexRoute,
  LocationsIndexRoute: LocationsIndexRoute,
  PlacementsIndexRoute: PlacementsIndexRoute,
  PortalIndexRoute: PortalIndexRoute,
  ReportingIndexRoute: ReportingIndexRoute,
  SponsorsIndexRoute: SponsorsIndexRoute,
  TeamIndexRoute: TeamIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
